import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/complexBetButtons.css';
// constants
import {EXACTA, EXACTA_BOX, TRIFECTA, TRIFECTA_BOX} from '../../../../modules/racing/constants/identifiers';
import {ASSETS_URL} from '../../../../../../constants/endpoints';
// helpers
import {
    compareBetRacers,
    createBet,
    generateBoxForecastPossibilities,
    generateBoxTricastPossibilities,
    generateForecastPossibilities,
    generateTricastPossibilities,
    getOpenBet,
    marketHasOpenBet
} from '../../../../helpers/betHelpers';
import {getChipValue, getClosestChipByValue} from '../../../../../../constants/chips';
import {getFormattedCurrency} from '../../../../../../helpers/localization';
import {sortRacersByOdd} from '../../../../modules/racing/helpers/racersHelper';
// actions
import {incrementBetValue} from '../../../../actions/openBetsActions';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip,
        openBetsHistory: state.vpp.openBetsHistory,
        isBoxBetsButtonToggled: state.vpp.isBoxBetsButtonToggled
    };
};

class ComplexBetButtons extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled
        });
    }

    _createBetChipsUI(selectedGame, selectedEvent, market, racers) {
        let betChipsUI = [];
        let totalStake;
        if (this.state.openBetsHistory && this.state.openBetsHistory.length) {
            let currBetHistory = this.state.openBetsHistory.filter((bet) => bet.game.channel === selectedGame.channel && bet.event.eventId === selectedEvent.eventId && bet.market.code === market.code && compareBetRacers(bet.racers, racers));

            if (currBetHistory && currBetHistory.length) {
                if (currBetHistory.length === 1) {
                    totalStake = currBetHistory[0].value;
                } else {
                    totalStake = currBetHistory.reduce((acc, betHist) => +acc + betHist.value, 0);
                }
            } else {
                return '';
            }

            betChipsUI = (<div id={'betChips_' + market.id} className={style.betChipsContainer}>
                <img key={'CHIP_STAKE'} className={style.betChips}
                     src={`${ASSETS_URL + getClosestChipByValue(totalStake).assetChip}`} alt={'chips'}/>
                <div className={style.chipValueOuter}>
                    <div
                        className={style.chipValueInner}>{getFormattedCurrency(this.props.store, totalStake / 100, 0)}</div>
                </div>
            </div>);
        }
        return betChipsUI;
    }

    _createExactaUI(selectedGame, selectedEvent, incrementValue) {
        let exactaUI = [];
        let market = {
            code: this.state.isBoxBetsButtonToggled
                ? EXACTA_BOX.code
                : EXACTA.code
        };
        let store = this.props.store;
        let storeData = store.getState();
        let oneHalfThough;
        let oneThirdThough;
        let arrayFirstColumn = [];
        let arraySecondColumn = [];
        let arrayThirdColumn = [];
        let betButtonsFirstColumn = [];
        let betButtonsSecondColumn = [];
        let betButtonsThirdColumn = [];

        if (storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.forecast) {

            let betPossibilities = this.state.isBoxBetsButtonToggled
                ? generateBoxForecastPossibilities(this.state.selectedEventMultiBetList)
                : generateForecastPossibilities(this.state.selectedEventMultiBetList);

            for (var i = 0; i < betPossibilities.length; i++) {
                betPossibilities[i].racers = [
                    this._getRacerByNum(betPossibilities[i].first),
                    this._getRacerByNum(betPossibilities[i].second)
                ];
                betPossibilities[i].odd = this.state.isBoxBetsButtonToggled
                    ? storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.reverseForecast[`${betPossibilities[i].first}-${betPossibilities[i].second}`]
                    : storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.forecast[`${betPossibilities[i].first}-${betPossibilities[i].second}`];
                betPossibilities[i].market = {
                    id: `${market.code}_${betPossibilities[i].first}-${betPossibilities[i].second}`,
                    code: market.code,
                    odds: betPossibilities[i].odd
                };
            }

            betPossibilities = betPossibilities.sort(sortRacersByOdd);

            if (betPossibilities.length < 2) {
                arrayFirstColumn = betPossibilities.slice();
            } else if (betPossibilities.length === 2 || betPossibilities.length === 4 || betPossibilities.length === 8 || betPossibilities.length === 10) {
                oneHalfThough = Math.floor(betPossibilities.length / 2);
                arrayFirstColumn = betPossibilities.slice(0, oneHalfThough);
                arraySecondColumn = betPossibilities.slice(oneHalfThough, betPossibilities.length);
            } else {
                oneThirdThough = Math.floor(betPossibilities.length / 3);
                arrayFirstColumn = betPossibilities.slice(0, oneThirdThough);
                arraySecondColumn = betPossibilities.slice(oneThirdThough, oneThirdThough * 2);
                arrayThirdColumn = betPossibilities.slice(oneThirdThough * 2, betPossibilities.length);
            }

            betButtonsFirstColumn = arrayFirstColumn.length
                ? arrayFirstColumn.map((bt, index) => this._createExactaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];

            betButtonsSecondColumn = arraySecondColumn.length
                ? arraySecondColumn.map((bt, index) => this._createExactaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];

            betButtonsThirdColumn = arrayThirdColumn.length
                ? arrayThirdColumn.map((bt, index) => this._createExactaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];
        }
        if (betButtonsFirstColumn && betButtonsSecondColumn && betButtonsThirdColumn) {
            exactaUI = [betButtonsFirstColumn, betButtonsSecondColumn, betButtonsThirdColumn];
        }

        return exactaUI;
    }

    _createExactaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue) {
        let oddsText;
        let oddsExacta = this.state.isBoxBetsButtonToggled
            ? storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.reverseForecast[`${bt.first}-${bt.second}`]
            : storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.forecast[`${bt.first}-${bt.second}`];
        let currentMarket = {
            id: `${market.code}_${bt.first}-${bt.second}`,
            code: market.code,
            odds: oddsExacta
        };
        let racers = [
            this._getRacerByNum(bt.first),
            this._getRacerByNum(bt.second)
        ];
        let isSelected = marketHasOpenBet(selectedGame, selectedEvent, currentMarket, racers, this.state.openBetsList);
        if (isSelected) {
            oddsText = getFormattedCurrency(this.props.store, (oddsExacta * getOpenBet(selectedGame, selectedEvent, currentMarket, racers, this.state.openBetsList).stake / 100).toFixed(2));
        } else {
            oddsText = getFormattedCurrency(this.props.store, (oddsExacta * incrementValue / 100).toFixed(2));
        }
        let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, currentMarket, racers);
        return (<div id={'exacta_' + index} className={`${style.button} ${isSelected
            ? style.selected
            : ''}`} key={'exacta_' + index}
                     onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, currentMarket, [
                         this._getRacerByNum(bt.first),
                         this._getRacerByNum(bt.second)
                     ], incrementValue), incrementValue, storeData.vpp.openBetsList))}>
            <div>
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${bt.first}.png`}
                    className={style.racerIconImage} alt={`icon${bt.first}`}/>
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${bt.second}.png`}
                    className={style.racerIconImage} alt={`icon${bt.second}`}/>
            </div>
            <div className={style.oddsText} id={`${bt.first}_${bt.second}`}>{oddsText}</div>
            {betChipsUI}
        </div>);
    }

    _createTrifectaUI(selectedGame, selectedEvent, incrementValue) {
        let trifectaUI;
        let market = {
            code: this.state.isBoxBetsButtonToggled
                ? TRIFECTA_BOX.code
                : TRIFECTA.code
        };
        let store = this.props.store;
        let storeData = store.getState();
        let oneHalfThough;
        let oneThirdThough;
        let arrayFirstColumn = [];
        let arraySecondColumn = [];
        let arrayThirdColumn = [];
        let betButtonsFirstColumn = [];
        let betButtonsSecondColumn = [];
        let betButtonsThirdColumn = [];

        if (storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast) {

            let betPossibilities = this.state.isBoxBetsButtonToggled
                ? generateBoxTricastPossibilities(this.state.selectedEventMultiBetList)
                : generateTricastPossibilities(this.state.selectedEventMultiBetList);

            for (var i = 0; i < betPossibilities.length; i++) {
                betPossibilities[i].racers = [
                    this._getRacerByNum(betPossibilities[i].first),
                    this._getRacerByNum(betPossibilities[i].second),
                    this._getRacerByNum(betPossibilities[i].third)
                ];
                betPossibilities[i].odd = this.state.isBoxBetsButtonToggled
                    ? storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.reverseTricast[`${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`]
                    : storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast[`${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`];
                betPossibilities[i].market = {
                    id: `${market.code}_${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`,
                    code: market.code,
                    odds: betPossibilities[i].odd
                };
            }

            betPossibilities = betPossibilities.sort(sortRacersByOdd);

            if (betPossibilities.length < 2) {
                arrayFirstColumn = betPossibilities.slice();
            } else if (betPossibilities.length === 2 || betPossibilities.length === 4 || betPossibilities.length === 8 || betPossibilities.length === 10) {
                oneHalfThough = Math.floor(betPossibilities.length / 2);
                arrayFirstColumn = betPossibilities.slice(0, oneHalfThough);
                arraySecondColumn = betPossibilities.slice(oneHalfThough, betPossibilities.length);
            } else {
                oneThirdThough = Math.floor(betPossibilities.length / 3);
                arrayFirstColumn = betPossibilities.slice(0, oneThirdThough);
                arraySecondColumn = betPossibilities.slice(oneThirdThough, oneThirdThough * 2);
                arrayThirdColumn = betPossibilities.slice(oneThirdThough * 2, betPossibilities.length);
            }

            betButtonsFirstColumn = arrayFirstColumn.length
                ? arrayFirstColumn.map((bt, index) => this._createTrifectaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];

            betButtonsSecondColumn = arraySecondColumn.length
                ? arraySecondColumn.map((bt, index) => this._createTrifectaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];

            betButtonsThirdColumn = arrayThirdColumn.length
                ? arrayThirdColumn.map((bt, index) => this._createTrifectaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue))
                : [];
        }

        if (betButtonsFirstColumn && betButtonsSecondColumn && betButtonsThirdColumn) {
            trifectaUI = [betButtonsFirstColumn, betButtonsSecondColumn, betButtonsThirdColumn];
        }

        return trifectaUI;
    }

    _createTrifectaColumn(bt, index, storeData, market, selectedGame, selectedEvent, incrementValue) {
        let oddsText;
        let oddsTrifecta = this.state.isBoxBetsButtonToggled
            ? storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.reverseTricast[`${bt.first}-${bt.second}-${bt.third}`]
            : storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast[`${bt.first}-${bt.second}-${bt.third}`];
        let currentMarket = {
            id: `${market.code}_${bt.first}-${bt.second}-${bt.third}`,
            code: market.code,
            odds: oddsTrifecta
        };
        let racers = [
            this._getRacerByNum(bt.first),
            this._getRacerByNum(bt.second),
            this._getRacerByNum(bt.third)
        ];
        let isSelected = marketHasOpenBet(selectedGame, selectedEvent, currentMarket, racers, this.state.openBetsList);
        if (isSelected) {
            oddsText = getFormattedCurrency(this.props.store, (oddsTrifecta * getOpenBet(selectedGame, selectedEvent, currentMarket, racers, this.state.openBetsList).stake / 100).toFixed(2));
        } else {
            oddsText = getFormattedCurrency(this.props.store, (oddsTrifecta * incrementValue / 100).toFixed(2));
        }
        let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, currentMarket, racers);
        return (<div id={'trifecta_' + index} className={`${style.button} ${isSelected
            ? style.selected
            : ''}`} key={'trifecta_' + index}
                     onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, currentMarket, racers, incrementValue), incrementValue, storeData.vpp.openBetsList))}>
            <div>
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${bt.first}.png`}
                    className={style.racerIconImage} alt={`icon${bt.first}`}/>
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${bt.second}.png`}
                    className={style.racerIconImage} alt={`icon${bt.second}`}/>
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${bt.third}.png`}
                    className={style.racerIconImage} alt={`icon${bt.third}`}/>
            </div>
            <div className={style.oddsText} id={`${bt.first}_${bt.second}_${bt.third}`}>{oddsText}</div>
            {betChipsUI}
        </div>);
    }

    _getRacerByNum(num) {
        return this.state.events[this.state.selectedEventIndex].racers.find(racer => racer.num.toString() === num.toString());
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let selectedChip = this.state.selectedChip;
        let incrementValue = getChipValue(selectedChip);

        let betButtonsFirstColumn;
        let betButtonsSecondColumn;
        let betButtonsThirdColumn;
        let exactaUI;
        let trifectaUI;

        switch (this.state.selectedRacingBetType) {
            case EXACTA:
                exactaUI = this._createExactaUI(selectedGame, selectedEvent, incrementValue);
                if (exactaUI && exactaUI.length) {
                    betButtonsFirstColumn = exactaUI[0];
                    betButtonsSecondColumn = exactaUI[1];
                    betButtonsThirdColumn = exactaUI[2];
                }
                break;
            case TRIFECTA:
                trifectaUI = this._createTrifectaUI(selectedGame, selectedEvent, incrementValue);
                if (trifectaUI && trifectaUI.length) {
                    betButtonsFirstColumn = trifectaUI[0];
                    betButtonsSecondColumn = trifectaUI[1];
                    betButtonsThirdColumn = trifectaUI[2];
                }
                break;
            default:
                break;
        }

        let betButtonsFirstColumnUI = betButtonsFirstColumn.length
            ? (<div className={style.buttonsColumn}>{betButtonsFirstColumn}</div>)
            : '';
        let betButtonsSecondColumnUI = betButtonsSecondColumn.length
            ? (<div className={style.buttonsColumn}>{betButtonsSecondColumn}</div>)
            : '';
        let betButtonsThirdColumnUI = betButtonsThirdColumn.length
            ? (<div className={style.buttonsColumn}>{betButtonsThirdColumn}</div>)
            : '';

        return (<div className={style.betButtons}>
            {betButtonsFirstColumnUI}
            {betButtonsSecondColumnUI}
            {betButtonsThirdColumnUI}
        </div>);
    }
}

export default connect(mapStateToProps)(ComplexBetButtons);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/components/complexBetButtons.js